
import { Component, Vue, Prop } from "vue-property-decorator"
import { MediaResource } from "@/resources"

@Component({ components: {} })
export default class PdfViewerComponent extends Vue {
  @Prop() readonly mediaResource!: MediaResource;
}
